'use client';

import { getFragmentData } from '@/__generated__';
import { EventEntryFragment } from '@/__generated__/graphql';
import Blocks from '@/components/Blocks';
import { EVENT_CARD_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { createToggleStore } from '@/lib/utils/createToggleStore';
import { excludeEmptyTypedElements } from '@liquorice/utils';
import EventLayoutDivider from './EventLayout.Divider';
import EventLayoutFaq from './EventLayout.Faq';

export const useEventTab = createToggleStore({
  allowNull: false,
  persistStoreKey: 'event-tab-store',
  defaultValue: false,
});

const EventLayoutBody = ({ blocks, faqMultiple, ...data }: EventEntryFragment) => {
  const { genreCategory } = getFragmentData(EVENT_CARD_FRAGMENT, data);
  const { value: eventFaqEnabled } = useEventTab();
  const faqs = excludeEmptyTypedElements(faqMultiple);

  return (
    <>
      {eventFaqEnabled ? <EventLayoutFaq data={faqs} /> : <Blocks key="blocks" blocks={blocks} />}
      <EventLayoutDivider key="divider" data={excludeEmptyTypedElements(genreCategory)} />
    </>
  );
};

export default EventLayoutBody;
